// removed by extract-text-webpack-plugin
module.exports = {"citat":"_1EHmY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Citat/Citat.scss
 ** module id = 436
 ** module chunks = 0
 **/